import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from "@/plugins/vue-i18n";
export class ExportAuditLog {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportAuditLog(auditLogs, startDate, endDate){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("log");
    worksheet.columns = [
      {
        header: i18n.t('date'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('type'),
        key: 2,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.edit_data'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('by'),
        key: 4,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
    ]
    
    for(let auditLog of auditLogs){
      worksheet.addRow({
        1: auditLog.createdAt ? new Date(moment(auditLog.createdAt).format("YYYY-MM-DD HH:mm:ss")) : "",
        2: auditLog.typeString,
        3: auditLog.detail,
        4: `${auditLog.createdBy.firstName} ${auditLog.createdBy.lastName}`,
      })
    }

    return this.saveFile(workbook, `auditlog-log-${moment(startDate).format("DD-MM-YYYY")}-to-${moment(endDate).format("DD-MM-YYYY")}`);
  }
}